<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-key-plus</v-icon>
                    </template>
                    <span>add promo-code</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                Add promo code for <span class="secondary--text">{{ institute.name }}</span>
            </v-card-title>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row justify="center">
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="secondary" 
                                    label="university" 
                                    v-model="name"
                                    name="university" 
                                    type="text" readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="secondary" 
                                    label="professor name" 
                                    v-model="user_name" 
                                    name="user_name"
                                    type="text">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense 
                                    color="secondary" 
                                    label="promo-code" 
                                    v-model="code" 
                                    name="code"
                                    type="text" 
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="secondary" 
                                    label="date of expired" 
                                    v-model="date_expired" 
                                    name="date_expired"
                                    type="text" readonly>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error mx-2">{{ error }}</v-row>
                <v-row justify="center" class="text-no-wrap mx-2">{{ message }}</v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" 
                    :disabled="!valid || Boolean(error)" @click="save">
                    Save
                </v-btn>
                <v-btn color="secondary" text class="text-capitalize" 
                    :disabled="!valid || Boolean(error)" @click="print">
                    Print
                </v-btn>
                <v-btn color="secondary" 
                    text class="text-capitalize" 
                    @click="closeDialog">
                    Reset
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { PromoCodeGenerator } from '../../../functions/common';
export default {
    name: 'AddPromo',
    props: ['institute'],
    data() {
        return {
            dialog: false,
            error: '',
            message: '',
            valid: false,
            name: this.institute.name,
            user_name: '',
            rules: {
                required: value => !!value || 'required field',
                max: v => v <= 5 || 'max 5 expected', 
            }
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        code: {
            get() {
                return PromoCodeGenerator(6);
            },
            set(val) {
                return val;
            }
        },
        date_expired: {
            get() {
                return this.dateToString(this.institute.date_expired);
            },
            set(val) {
                return val;
            }
        }
    },
    methods: {
        dateToString(date) {
            return date.toLocaleString('en-GB', { timeZone: 'UTC' }).substr(0, 10);
        },
        closeDialog() {
            this.dialog = false
            this.message = ''
            this.error = ''
            this.name = this.institute.name;
            this.user_name = '';
        },
        async print() {
            if (this.$refs.form.validate()) {
                
                const promo = {
                    code: this.code,
                    institute: this.institute.name,
                    user_name: this.user_name,
                }
                //console.log(promo)
                try {
                    await this.$store.dispatch('printCode', promo);
                    this.closeDialog();
                }
                catch (error) {
                    this.error = error.message
                }  
            } 
        },
        async save() {
            if (this.$refs.form.validate()) {
                
                const promo = {
                    code: this.code,
                    instituteId: this.institute.id,
                    user_name: this.user_name,
                }
                //console.log(promo)
                try {
                    await this.$store.dispatch('addCode', promo);
                    this.closeDialog();
                }
                catch (error) {
                    this.error = error.message
                }  
            }  
        },
    }
}
</script>